import React, { useState, useEffect } from "react";
import mainFooterUsefulLinks from "./mainFooterUsefulLinks";
import { Link } from "react-router-dom";
import classes from "./MainFooterUsefulLink.module.css";
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";
import { useSelector } from "react-redux";

const MainFooterUsefulLink = () => {
  const [toggleUsefulLinks, setToggleUsefulLinks] = useState(true);

  const browserWidth = useSelector((state) => state.browserData.browserWidth);

  useEffect(() => {
    if (browserWidth > 768) {
      setToggleUsefulLinks(true);
    }
  }, [browserWidth]);

  return (
    <div className={classes["main-footer-container__useful-links"]}>
      <div>
        <h2>Useful Links</h2>
        <span
          onClick={() => {
            setToggleUsefulLinks((prev) => {
              return !prev;
            });
          }}
        >
          {!toggleUsefulLinks ? <AiFillCaretDown /> : <AiFillCaretUp />}
        </span>
      </div>

      {toggleUsefulLinks &&
        mainFooterUsefulLinks.map((link, index) => {
          const { path, name } = link;
          return (
            <Link to={path} key={index}>
              {name}
            </Link>
          );
        })}
    </div>
  );
};

export default MainFooterUsefulLink;
